import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Spinner,
  Nav,
  Navbar,
} from "react-bootstrap";
import instance from "../../services/endpoint";
import { toast } from "react-toastify";
import img from "../../images/Logo.png";
import logoImg from "../../images/Logo.png";
import signup from "../../images/signup.png";
import Loader from "../utilComponents/loader";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import { useParams } from "react-router-dom";

const RegisterForm = () => {
  const navigate = useNavigate();
  const params = useParams();

  const [step, setStep] = useState(1);
  const [value, setValue] = useState({
    FullName: "",
    Email: "",
    Password: "",
    Phone: "",
    Account_Type: "",
    Address: "",
    referralID: "",
  });

  useEffect(() => {
    console.log("Referral ID from URL:", params.referralID);
    setValue((prev) => ({
      ...prev,
      referralID: params?.referralID || "",
    }));
  }, [params]);

  const [fieldErrors, setFieldErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateFields = (fields) => {
    const errors = {};
    if (fields.includes("FullName") && !value.FullName) {
      errors.FullName = "Full name is required.";
    }
    if (fields.includes("Email")) {
      if (!value.Email) {
        errors.Email = "Email is required.";
      } else if (!value.Email.includes("@") || !value.Email.includes(".")) {
        errors.Email = 'Email must contain "@" and ".".';
      }
    }
    if (fields.includes("Password")) {
      const passwordRegex =
        /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
      if (!value.Password) {
        errors.Password = "Password is required.";
      } else if (!passwordRegex.test(value.Password)) {
        errors.Password =
          "Password must include one uppercase letter, one special symbol, one number and be 8-20 characters long.";
      }
    }
    if (fields.includes("Phone") && !value.Phone) {
      errors.Phone = "Phone number is required.";
    }
    if (fields.includes("Account_Type") && !value.Account_Type) {
      errors.Account_Type = "Account type is required.";
    }
    if (fields.includes("Address") && !value.Address) {
      errors.Address = "Address is required.";
    }
    if (fields.includes("referralID") && value.referralID) {
      const referralRegex = /^[A-Z]{4}\d{6}$/;
      if (!referralRegex.test(value.referralID)) {
        errors.referralID =
          "Referral ID must be 4 uppercase letters followed by 6 digits (e.g. SYED123456).";
      }
    }

    return errors;
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    const errors = validateFields(["FullName", "Email", "Password", "Phone"]);
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    setFieldErrors({});
    setStep(2);
  };

  const handlePreviousStep = (e) => {
    e.preventDefault();
    setStep(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFields(["Account_Type", "Address", "referralID"]);
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setIsLoading(true);
    setLoading(true);
    setError(null);

    try {
      await instance.post("/api/v1/auth/register", value);
      setIsLoading(false);
      setSuccess(true);
      toast.success("User registered successfully");
      navigate("/login");
    } catch (error) {
      setIsLoading(false);
      setError(
        error.response?.data?.message || "An unexpected error occurred."
      );
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Bitstek Advisory | Register";
    if (success) {
      setSuccess(false);
    }
  }, [success]);

  return (
    <>
      {loading && <Loader />}
      <Navbar
        expand="lg"
        style={{ background: "linear-gradient(135deg, black, #b59f5b)" }}
        className="fixed-top">
        <Container>
          <Navbar.Brand href="/homepage" className="d-flex align-items-center">
            <img
              src={logoImg}
              width="40"
              height="50"
              className="d-inline-block align-top me-2"
              alt="Logo"
            />
            <span className="fw-bold" style={{ color: "white" }}>
              Bitstek Advisory
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end">
            <Nav className="align-items-center">
              <Button
                variant="primary"
                className="px-4"
                style={{
                  border: "none",
                  color: "white",
                  fontWeight: "bold",
                  background: "transparent",
                }}
                onClick={() => navigate("/login")}>
                LOGIN
              </Button>

              {/* Sign Up Button */}
              <Button
                variant="primary"
                className="px-4"
                style={{
                  borderRadius: "20px",
                  background: "#D4AF37",
                  border: "none",
                }}
                onClick={() => navigate("/register")}>
                SIGN UP
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, black, #b59f5b)",
        }}>
        <div
          className="d-flex align-items-center "
          style={{ maxWidth: "900px", width: "100%" }}>
          {/* Image Section */}
          <div
            className="d-none d-md-block"
            style={{ flex: 1, textAlign: "center" }}>
            {/* <iframe
              src="https://lottie.host/embed/dca1a9c7-91c6-4dfd-9826-6bfca111dcee/5CpQiXllWx.lottie"
              alt="Login"
              style={{
                maxWidth: "100%",
                height: "30rem",
                width: "60rem",
                borderRadius: "10px",
                marginLeft: "-300px",
              }}></iframe> */}
              <img
              src={signup}
              style={{
                maxWidth: "100%",
                height: "30rem",
                width: "60rem",
                borderRadius: "10px",
                marginLeft: "-300px",
              }}
              className="d-inline-block align-top me-2"
              alt="Logo"
            />
          </div>

          {/* Login Box */}
          <div
            style={{
              backgroundColor: "#000",
              padding: "30px",
              borderRadius: "8px",
              border: "1px solid #d4af37",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              marginTop: "80px",
              marginRight: "-115px",
            }}>
            <Row>
              <Col>
                <div className="text-center">
                  <img
                    src={img}
                    alt="Bitstek Advisory Logo"
                    style={{ width: "150px", borderRadius: "230px" }}
                  />
                </div>
                <Form onSubmit={step === 1 ? handleNextStep : handleSubmit}>
                  <h5 className="mb-4" style={{ color: "#e5c15f" }}>
                    Register to Bitstek Advisory
                  </h5>

                  {step === 1 && (
                    <>
                      <Form.Group className="mb-3" controlId="formFullName">
                        <Form.Control
                          type="text"
                          name="FullName"
                          placeholder="Enter your full name"
                          value={value.FullName}
                          onChange={(e) =>
                            setValue({ ...value, FullName: e.target.value })
                          }
                        />
                        {fieldErrors.FullName && (
                          <small
                            className="text-danger"
                            style={{ marginTop: "6px", display: "block" }}>
                            {fieldErrors.FullName}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Control
                          type="text"
                          name="Email"
                          placeholder="Enter your email"
                          value={value.Email}
                          onChange={(e) =>
                            setValue({ ...value, Email: e.target.value })
                          }
                        />
                        {fieldErrors.Email && (
                          <small
                            className="text-danger"
                            style={{ marginTop: "6px", display: "block" }}>
                            {fieldErrors.Email}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3 " controlId="formPassword">
                        <div style={{ position: "relative" }}>
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            name="Password"
                            placeholder="Enter your password"
                            value={value.Password}
                            onChange={(e) => {
                              const newPassword = e.target.value;
                              setValue({ ...value, Password: newPassword });

                              const passwordRegex =
                                /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
                              if (!passwordRegex.test(newPassword)) {
                                setFieldErrors((prevErrors) => ({
                                  ...prevErrors,
                                  Password:
                                    "Password must include one uppercase letter, one special symbol, one number and be 8-20 characters long.",
                                }));
                              } else {
                                const { Password, ...restErrors } = fieldErrors;
                                setFieldErrors(restErrors);
                              }
                            }}
                            required
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontSize: "1.5rem",
                              color: "#D4AF37",
                            }}>
                            {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
                          </span>
                        </div>
                        {fieldErrors.Password && (
                          <small
                            className="text-danger"
                            style={{ display: "block", marginTop: "5px" }}>
                            {fieldErrors.Password}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group
                        className="mb-3 d-flex align-items-center"
                        controlId="formPhone">
                        <Form.Select
                          name="CountryCode"
                          value={value.CountryCode || "+91"} // Default country code
                          onChange={(e) =>
                            setValue({ ...value, CountryCode: e.target.value })
                          }
                          style={{ maxWidth: "100px", marginRight: "10px" }}>
                          <option value="+91">+91 (India)</option>
                          <option value="+1">+1 (USA)</option>
                          <option value="+44">+44 (UK)</option>
                          <option value="+61">+61 (Australia)</option>
                          <option value="+81">+81 (Japan)</option>
                          <option value="+49">+49 (Germany)</option>
                          <option value="+33">+33 (France)</option>
                          <option value="+86">+86 (China)</option>
                          <option value="+971">+971 (UAE)</option>
                          <option value="+92">+92 (Pakistan)</option>
                          {/* Add more country codes as needed */}
                        </Form.Select>
                        <Form.Control
                          type="tel"
                          name="Phone"
                          placeholder="Enter your phone number"
                          value={value.Phone}
                          onChange={(e) =>
                            setValue({ ...value, Phone: e.target.value })
                          }
                        />
                        {fieldErrors.Phone && (
                          <small className="text-danger">
                            {fieldErrors.Phone}
                          </small>
                        )}
                      </Form.Group>
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <Form.Group className="mb-2" controlId="formAddress">
                        <Form.Label style={{ fontSize: "0.8rem", margin: "0 0 1px -16rem", color: "white" }}>Referral ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="referralID"
                          placeholder="Enter your referral ID (optional)"
                          value={value.referralID}
                          readOnly={!!params.referralID} // only read-only if from URL
                          onChange={(e) =>
                            setValue({
                              ...value,
                              referralID: e.target.value.toUpperCase(),
                            })
                          }
                        />

                        {fieldErrors.referralID && (
                          <small className="text-danger">
                            {fieldErrors.referralID}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-2" controlId="formAccountType">
                        <Form.Label style={{ fontSize: "0.8rem", margin: "0 0 1px -15rem", color: "white" }}>Account Type</Form.Label>
                        <Form.Select
                          name="Account_Type"
                          value={value.Account_Type}
                          onChange={(e) =>
                            setValue({ ...value, Account_Type: e.target.value })
                          }
                          required>
                          <option value="">Select Account Type</option>
                          <option value="Classic">Classic</option>
                          <option value="Premium">Premium</option>
                          <option value="Business">Business</option>
                          <option value="Enterprise">Enterprise</option>
                        </Form.Select>
                        {fieldErrors.Account_Type && (
                          <small className="text-danger">
                            {fieldErrors.Account_Type}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label style={{ fontSize: "0.8rem", margin: "0 0 1px -17rem", color: "white" }}>Address</Form.Label>
                        <Form.Control
                          type="text"
                          name="Address"
                          placeholder="Enter your address"
                          value={value.Address}
                          onChange={(e) =>
                            setValue({ ...value, Address: e.target.value })
                          }
                          required
                        />
                        {fieldErrors.Address && (
                          <small className="text-danger">
                            {fieldErrors.Address}
                          </small>
                        )}
                      </Form.Group>

                      <Button
                        variant="secondary"
                        onClick={handlePreviousStep}
                        className="w-100 mb-2">
                        Previous
                      </Button>
                    </>
                  )}

                  {error && <p className="text-danger">{error}</p>}

                  {isLoading ? (
                    <Spinner animation="border" className="d-block mx-auto" />
                  ) : (
                    <Button variant="warning" type="submit" className="w-100">
                      {step === 1 ? "Next" : "Submit"}
                    </Button>
                  )}
                </Form>

                <div className="text-center mt-3">
                  <Link to="/login" className="text-warning">
                    Already have an account? Login
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
};

export default RegisterForm;
